/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IaaCProjectMemberDTO } from './IaaCProjectMemberDTO';
import {
    IaaCProjectMemberDTOFromJSON,
    IaaCProjectMemberDTOFromJSONTyped,
    IaaCProjectMemberDTOToJSON,
} from './IaaCProjectMemberDTO';

/**
 * 
 * @export
 * @interface IaaCProjectMembersListDTO
 */
export interface IaaCProjectMembersListDTO {
    /**
     * 
     * @type {Array<IaaCProjectMemberDTO>}
     * @memberof IaaCProjectMembersListDTO
     */
    members: Array<IaaCProjectMemberDTO>;
}

/**
 * Check if a given object implements the IaaCProjectMembersListDTO interface.
 */
export function instanceOfIaaCProjectMembersListDTO(value: object): value is IaaCProjectMembersListDTO {
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function IaaCProjectMembersListDTOFromJSON(json: any): IaaCProjectMembersListDTO {
    return IaaCProjectMembersListDTOFromJSONTyped(json, false);
}

export function IaaCProjectMembersListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IaaCProjectMembersListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'members': ((json['members'] as Array<any>).map(IaaCProjectMemberDTOFromJSON)),
    };
}

export function IaaCProjectMembersListDTOToJSON(value?: IaaCProjectMembersListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'members': ((value['members'] as Array<any>).map(IaaCProjectMemberDTOToJSON)),
    };
}

